import React from 'react';
import { string, shape, arrayOf } from 'prop-types';
import Media from '../media';
import StyledLabel from '../styled-label';
import Actions from '../buybox/actions/actions';
import Benefits from '../benefits/benefits';
import { generateKeyToComponent } from '../../utils/validators';
import IconFactory from '../icons/factory-builder';

const namespace = 'ui-vip-reservation';

const ReservationInfo = ({ header, content_rows, extra_info, footer_benefits, actions }) => (
  <div className={`${namespace} ui-box-component`}>
    <StyledLabel as="h2" {...header} className={`${namespace}__header mb-32`} />
    {content_rows.map(content => (
      <Media
        key={generateKeyToComponent(content)}
        className={`${namespace}__content`}
        figure={IconFactory(content.icon)}
        title={content.title}
        subtitles={content.subtitles}
      />
    ))}
    {extra_info.map(info => (
      <Media key={generateKeyToComponent(info)} className={`${namespace}__extra-info`} title={info} />
    ))}
    {actions && <Actions actions={actions} />}
    {footer_benefits && <Benefits benefits={footer_benefits} className={`${namespace}__list-benefits`} />}
  </div>
);

ReservationInfo.propTypes = {
  header: shape({
    text: string,
    font_size: string,
    color: string,
    font_family: string,
  }).isRequired,
  content_rows: arrayOf({
    icon: shape({
      id: string,
      color: string,
    }),
    title: shape({
      text: string,
      font_size: string,
      color: string,
      font_family: string,
    }),
    subtitles: shape(),
  }).isRequired,
  extra_info: arrayOf(
    shape({
      text: string,
      values: shape(),
    }),
  ).isRequired,
  footer_benefits: arrayOf({
    text: string,
    icon: shape({
      id: string,
      color: string,
    }),
  }),
  actions: arrayOf({
    type: string,
    target: string,
    label: shape({
      text: string,
    }),
    action_type: string,
  }).isRequired,
};

ReservationInfo.defaultProps = {
  footer_benefits: null,
};

export default React.memo(ReservationInfo);
